<template>

    <ModalAddPlano :isVisible="isVisibleModalAddPlano" @close="isVisibleModalAddPlano = false"></ModalAddPlano>

    <ModalEditPlano :plano="planoEdit" :isVisible="isVisibleModalEditPlano" @close="isVisibleModalEditPlano = false">
    </ModalEditPlano>

    <div class="d-flex">

        <NavBarLeft path="/planos"></NavBarLeft>

        <div class="flex-1">

            <HeaderPage title="Planos" subtitle="Gerenciamento de Planos"></HeaderPage>

            <div class="m-2 p-2 bg-white">

                <div class="mb-2 text-end d-flex gap-1 justify-content-end">

                    <ButtonField @click="isVisibleModalAddPlano = true" icon="ri-add-line" type="success" size="small"
                        text="Adicionar Plano"></ButtonField>

                </div>

                <BaseTable :columns="dataTableHead" :rows="planosStore.planos" :paginationOptions="{ perPage: 50 }">

                    <template #table-row="{ column, row }">

                        <!-- Coluna de Ações -->
                        <template v-if="column.field == '__actions'">

                            <span>
                                <DropdownFloating v-model:shown="row.dropdownShown" :distance="6"
                                    placement="left-start">

                                    <div class="">
                                        <i class="ri-more-fill cursor-pointer"></i>
                                    </div>


                                    <template #popper>
                                        <div class="p-2 d-flex gap-2 flex-column">

                                            <OptionActionDataTable @click="openModalEditPlano(row)" text="Editar"
                                                icon="ri-pencil-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable @click="deletarPlano(row)" text="Deletar"
                                                icon="ri-delete-bin-line" textColor="danger">
                                            </OptionActionDataTable>

                                        </div>
                                    </template>
                                </DropdownFloating>
                            </span>

                        </template>

                        <!-- Colunas de valor -->
                        <template v-else-if="column.field == 'valor'">
                            {{ $moneyConvert.convert(row.valor) }}
                        </template>

                        <!-- Colunas normais -->
                        <template v-else>
                            {{ row[column.field] }}
                        </template>
                    </template>

                </BaseTable>

            </div>

        </div>

    </div>
</template>


<script>
import ModalAddPlano from '@/components/modais/ModalAddPlano.vue'
import ModalEditPlano from '@/components/modais/ModalEditPlano.vue'
import { useModulosStore } from '@/stores/modulos.js'
import { usePlanosStore } from '@/stores/planos'
import { toast } from 'vue3-toastify'

export default {
    name: 'AppPage',
    data() {
        return {

            dataTableHead:
                [
                    { label: 'Id', field: 'id', tdClass: 'td-vertical-middle' },
                    { label: 'Nome', field: 'nome', tdClass: 'td-vertical-middle' },
                    { label: 'Valor', field: 'valor', tdClass: 'td-vertical-middle' },
                    { label: 'Ações', field: '__actions', sortable: false, tdClass: 'td-actions td-vertical-middle text-center' }
                ]
            ,
            modulosStore: useModulosStore(),
            planosStore: usePlanosStore(),

            isVisibleModalAddPlano: false,

            isVisibleModalEditPlano: false,
            planoEdit: {}
        }
    },
    components: { ModalEditPlano, ModalAddPlano },
    methods: {
        async openModalEditPlano(plano) {
            plano.dropdownShown = false

            this.$notiflix.Loading.standard('Buscando Informações')
            const result = await this.planosStore.getOne(plano.id)

            if(!result.status)
            {
                this.$notiflix.Loading.remove()
                return false
            }

            const planoEdit = result.plano
            const planoEditObj = {
                id: planoEdit.id,
                nome: planoEdit.nome,
                valor: planoEdit.valor,
                descricao: planoEdit.descricao,
                modulos: planoEdit.modulos.map(m => m.id),
                parcerias: planoEdit.parcerias
            }
            this.planoEdit = planoEditObj
            this.isVisibleModalEditPlano = true
            this.$notiflix.Loading.remove()
        },
        deletarPlano(plano) {

            plano.dropdownShown = false
            this.$swal({
                title: 'Tem certeza?',
                text: `Você realmente deseja deletar esse plano?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$notiflix.Loading.standard('Deletando Plano')
                    const result = await this.planosStore.delete(plano)
                    this.$notiflix.Loading.remove()

                    if (result.status) {
                        toast.success("Plano deletado com sucesso")
                        this.planosStore.get()
                    } else {
                        toast.error(result.message)
                    }
                }
            })

        }
    },
    mounted() {
        this.modulosStore.get()
        this.planosStore.get()
    }
}
</script>